module.exports = __webpack_public_path__ + "static/media/logo.fc590f5f.svg";